import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgWarningFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 16 16",
	fill: "inherit",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM8.65454 5.19983C8.65454 4.83739 8.36073 4.54358 7.99829 4.54358C7.63585 4.54358 7.34204 4.83739 7.34204 5.19983V7.99983C7.34204 8.36227 7.63585 8.65608 7.99829 8.65608C8.36073 8.65608 8.65454 8.36227 8.65454 7.99983V5.19983ZM7.99829 10.1436C7.63585 10.1436 7.34204 10.4374 7.34204 10.7998C7.34204 11.1623 7.63585 11.4561 7.99829 11.4561H8.00529C8.36773 11.4561 8.66154 11.1623 8.66154 10.7998C8.66154 10.4374 8.36773 10.1436 8.00529 10.1436H7.99829Z"
	})
});
export default SvgWarningFilled;
